<template>
	<v-layout>
		<v-container fluid class="minus-ingredients ">
			<v-layout v-if="showFlexibleIngredientsOptions" row wrap class="spacing-box flexible-ingredients" data-cy="productConfigCheckboxes">
				<v-flex
					v-for="(option,i) in config.options.options"
					:key="i"
					:class="{'xs6': !isSingleMenuPage, 'xs12': isSingleMenuPage}"
				>
					<v-layout class="sub-product-wrapper" data-apm-span="wrapper-product-config">
						<div class="sub-product-content">
							<div class="option-name" :class="{'option-name-bold': selectedOptions.includes(i)}" :data-cy="option.name">
								{{ option.name | translate(`productConfiguration.${config.id}.options[${i}].name`) }}
							</div>
						</div>
						<div :key="option.id" @click.stop class="add-remove-btn-wrapper">
							<div v-if="shouldShowMaxIngredientMessageIndex === i" class="max-ingredient-message show-max-ingredient-message">
								{{ $t("common.maxIngredientsMessage") }}
								{{ shouldShowIngredientAsAmountOption(option) ? extraIngredientsLimit : 1 }}
							</div>
							<div class="add-remove-btn">
								<v-btn
									flat class="remove-button"
									:ripple="false"
									data-gtm-remove-from-cart="true"
									@click.prevent="removeIngredient(i)"
								>
									<div class="remove-image">
										<SvgIconMinus />
									</div>
								</v-btn>
								<v-chip label class="add-quantity"> {{ getConfigQuantity(i) }} </v-chip>
								<v-btn
									flat class="add-button"
									:ripple="false"
									data-gtm-add-to-cart="true"
									@click.prevent="addIngredient(i, option)"
									:class="{'add-button-disabled': getConfigQuantity(i) === extraIngredientsLimit || (getConfigQuantity(i) === 1 && !shouldShowIngredientAsAmountOption(option))}"
								>
									<div class="add-image">
										<SvgIconPlus />
									</div>
								</v-btn>
							</div>
							<div
								v-if="getConfigQuantity(i) > 0 && shouldShowIngredientAsAmountOption(option)"
								class="change-quantity-price"
							>
								+{{ formatPriceZero(getAdditionalPrice(option)) }}
							</div>
						</div>
					</v-layout>
					<hr class="divider subproduct-divider" v-if="i + 1 < config.options.options.length" :key="`divider-${i}`">
				</v-flex>
			</v-layout>
			<v-layout v-else row wrap class="spacing-box" :class="{'regular-ingredients-one-step-menu' : isSingleMenuPage}" data-cy="productConfigCheckboxes">
				<v-flex
					v-for="(option, i) in config.options.options"
					:key="i" :class="{'xs6': !isSingleMenuPage, 'xs12': isSingleMenuPage}"
				>
					<v-layout @click="changeSelection(i, selectedOptions.includes(i))" class="sub-product-wrapper" data-apm-span="wrapper-product-config">
						<v-checkbox class="subproduct-checkbox subproduct-ingredients-checkbox"
									:key="i"
									:value="i"
									v-model="selectedOptions"
									hide-details
									name="product-config-checkbox"
									data-apm-span="product-config-checkbox"
									@click.stop="changeSelection(i, selectedOptions.includes(i))"
									:data-cy="option.name"
						>
						</v-checkbox>
						<div class="sub-product-content">
							<div class="option-name" :class="{'option-name-bold': selectedOptions.includes(i)}" :data-cy="option.name">
								{{ option.name | translate(`productConfiguration.${config.id}.options[${i}].name`) }}
								<template v-if="!selectedOptions.includes(i)" class="standard-excluded">({{$t("shopComponents.gt3.productCatalog.productConfigCheckBoxGrid.deselected")}})</template>
							</div>
						</div>
					</v-layout>
					<hr class="divider subproduct-divider" v-if="i + 1 < config.options.options.length" :key="`divider-${i}`">
				</v-flex>
			</v-layout>
		</v-container>
	</v-layout>
</template>

<script>
	import * as Utils from "../../../../libraries/utils";
	import {UPDATE_PRODUCT_SELECTIONS} from "../../../../store/mutation-types";
	import _ from "lodash";
	import {formatPriceZero} from "../../../../domains2/libraries/Utils";
	import SvgIconPlus from "../../gt2/ProductCatalog/SvgIconPlus.vue";
	import SvgIconMinus from "../../gt2/ProductCatalog/SvgIconMinus.vue";

	export default {
		name: "ProductConfigCheckBoxGrid-gt3",
		props: [
			"config",
			"index",
			"changeConfigSelection",
			"mainGroup",
			"subProduct",
			"productSelections",
			"isFixedMenu",
			"selectedValues",
			"isMenu",
			"isSingleMenuPage"
		],
		components: {SvgIconPlus, SvgIconMinus},
		computed: {
			extraIngredientsLimit() {
				return this.$store.getters.tenantSettings.ingredientsLimit || 10;
			},
			productSelectionId() {
				return this.$route.params.productSelectionId;
			},
			showFlexibleIngredientsOptions() {
				const ps = (this.productSelections || []).find(ps => ps.productSelectionId === this.productSelectionId);
				return this.$store.getters.featureToggles.showFlexibleIngredientsOptions
					&& ps
					&& ps.groups
					&& ps.groups[0];
			},
			staticPath() {
				return Utils.getStaticPath();
			},
			configOptionsComputed() {
				return this.config;
			}
		},
		data() {
			return {
				selectedOptions: [],
				newProductSelections: [],
				shouldShowMaxIngredientMessageIndex: null
			};
		},
		mounted() {
			const self = this;
			self.selectedOptions = self.selectedValues ? self.selectedValues : [];
			this.config.options.options = this.config.options.options.map((option, i) => {
				const addedToCart = option.productId && this.isAddedToCart(option);
				if(!this.selectedOptions.includes(i) && !addedToCart) {
					option.quantity = 0;
				}
				if(this.selectedOptions.includes(i) && !addedToCart) {
					option.quantity = 1;
				}
				if(addedToCart) {
					option.quantity = (addedToCart.quantity + 1) || 1;
				}
				return option;
			});
		},
		methods: {
			addIngredient(i, option) {
				if(this.getConfigQuantity(i) === this.extraIngredientsLimit || (this.getConfigQuantity(i) === 1 && !this.shouldShowIngredientAsAmountOption(option))) {
					this.shouldShowMaxIngredientMessageIndex = i;
					const ingredientAnimation = document.querySelector(".max-ingredient-message.show-max-ingredient-message");
					if(ingredientAnimation) {
						ingredientAnimation.classList.remove("show-max-ingredient-message");
						setTimeout(()=> {
							ingredientAnimation.classList.add("show-max-ingredient-message");
						});
					}
					return;
				}
				if(this.getConfigQuantity(i) < this.extraIngredientsLimit) {
					if (!this.selectedOptions.includes(i)) {
						this.selectedOptions.push(i);
						this.configOptionsComputed.options.options[i].quantity = 1;
						this.changeSelection(i, false);
					} else {
						this.addIngredientToCart(option, i);
					}
				} else {
					this.changeSelection(i, false);
				}
				this.$forceUpdate();
			},
			removeIngredient(i) {
				if(this.getConfigQuantity(i) === 0) {
					return;
				}
				if(this.getConfigQuantity(i) === 1) {
					this.changeSelection(i, true, true);
				} else {
					this.changeSelection(i, false, true);
				}
				this.$forceUpdate();
			},
			formatPriceZero,
			hasForcedOnlinePosConfig(option) {
				const product = this.$store.getters.productCatalog.getProduct(option.productId);
				return product
					&& product.foreignIds
					&& product.foreignIds.onlinePosRules
					&& product.foreignIds.onlinePosRules.cart
					&& product.foreignIds.onlinePosRules.cart[0]
					&& product.foreignIds.onlinePosRules.cart[0].forcedConfig;
			},
			shouldShowIngredientAsAmountOption(option) {
				if(!option.productId) {
					return false;
				}
				const additionalPrice = this.getAdditionalPrice(option);
				const hasForcedOnlinePosConfig = this.hasForcedOnlinePosConfig(option);
				return option && option.productId && additionalPrice && hasForcedOnlinePosConfig;
			},
			isAddedToCart(option) {
				const ps = (this.productSelections || []).find(ps => ps.productSelectionId === this.productSelectionId);
				if(!ps) {
					return false;
				}
				if(this.isMenu) {
					const productIndex = ps.groups[0].selectedProducts[0].groups[0].selectedProducts.findIndex((idx) => idx.productId === option.productId);
					return ps.groups[0].selectedProducts[0].groups[0].selectedProducts[productIndex];
				}
				const groupToAppendIngredient = ps.groups && ps.groups.find(g => g.appearance === "checklist" || g.appearance === "amount");
				if(groupToAppendIngredient) {
					const productIndex = groupToAppendIngredient.selectedProducts.findIndex((idx) => idx.productId === option.productId);
					return groupToAppendIngredient.selectedProducts[productIndex];
				}
				return null;
			},
			addIngredientToCart(option, index, quantity = 0) {
				if(!option.productId || this.configOptionsComputed.options.options[index].quantity === this.extraIngredientsLimit) {
					return;
				}
				this.newProductSelections = [...this.productSelections];
				const ps = this.newProductSelections.find(ps => ps.productSelectionId === this.productSelectionId);
				if(this.isMenu) {
					const productIndex = ps.groups[0].selectedProducts[0].groups[0].selectedProducts.findIndex((idx) => idx.productId === option.productId);
					if(productIndex === -1) {
						ps.groups[0].selectedProducts[0].groups[0].selectedProducts.push({quantity: 1, productId: option.productId});
					} else {
						if(quantity) {
							ps.groups[0].selectedProducts[0].groups[0].selectedProducts[productIndex].quantity = quantity - 1;
						} else {
							ps.groups[0].selectedProducts[0].groups[0].selectedProducts[productIndex].quantity += 1;
						}
					}
				} else {
					const groupToAppendIngredient = ps.groups && ps.groups.find(g => g.appearance === "checklist" || g.appearance === "amount");
					if(groupToAppendIngredient) {
						const productIndex = groupToAppendIngredient.selectedProducts.findIndex((idx) => idx.productId === option.productId);
						if(productIndex === -1) {
							groupToAppendIngredient.selectedProducts.push({quantity: 1, productId: option.productId});
						} else {
							if(quantity) {
								groupToAppendIngredient.selectedProducts[productIndex].quantity = quantity - 1;
							} else {
								groupToAppendIngredient.selectedProducts[productIndex].quantity += 1;
							}
						}
					}
				}
				this.configOptionsComputed.options.options[index].quantity = quantity
					? quantity
					: this.configOptionsComputed.options.options[index].quantity + 1;
				this.$store.commit(UPDATE_PRODUCT_SELECTIONS, _.cloneDeep(this.newProductSelections));
			},
			removeIngredientFromCart(option) {
				if(!option.productId) {
					return;
				}
				this.newProductSelections = [...this.productSelections];
				const ps = this.newProductSelections.find(ps => ps.productSelectionId === this.productSelectionId);
				if(this.isMenu) {
					const productIndex = ps.groups[0].selectedProducts[0].groups[0].selectedProducts.findIndex((idx) => idx.productId === option.productId);
					if(productIndex !== -1) {
						ps.groups[0].selectedProducts[0].groups[0].selectedProducts.splice(productIndex, 1);
					}
				} else {
					const groupToAppendIngredient = ps.groups && ps.groups.find(g => g.appearance === "checklist" || g.appearance === "amount");
					if(groupToAppendIngredient) {
						const productIndex = groupToAppendIngredient.selectedProducts.findIndex((idx) => idx.productId === option.productId);
						if(productIndex !== -1) {
							groupToAppendIngredient.selectedProducts.splice(productIndex, 1);
						}
					}
				}
				this.$store.commit(UPDATE_PRODUCT_SELECTIONS, _.cloneDeep(this.newProductSelections));
			},
			getConfigQuantity(i) {
				if(isNaN(parseInt(this.configOptionsComputed.options.options[i].quantity))) {
					return this.configOptionsComputed.options.options[i].quantity;
				}
				return this.configOptionsComputed.options.options[i].quantity;
			},
			getAdditionalPrice(option) {
				if(!option.productId) {
					return 0;
				}
				const product = this.$store.getters.productCatalog.getProduct(option.productId);
				if(!product) {
					return;
				}
				if(!isNaN(parseInt(product.price))) {
					return product.price;
				}
				return product.priceStructure ? product.priceStructure.defaultPrice : 0;
			},
			changeSelection(index, isDeselect = false, shouldRemoveFromCart = true) {
				const self = this;
				if(this.configOptionsComputed.options.options[index].quantity === 0 && isDeselect) {
					return;
				}
				if(this.configOptionsComputed.options.options[index].quantity - 1 > 1) {
					this.configOptionsComputed.options.options[index].quantity -= 1;
					this.addIngredientToCart(
						this.configOptionsComputed.options.options[index],
						index,
						this.configOptionsComputed.options.options[index].quantity
					);
					return;
				}
				if (self.selectedOptions.includes(index) && isDeselect) {
					self.selectedOptions.splice(self.selectedOptions.indexOf(index), 1);
					this.configOptionsComputed.options.options[index].quantity = 0;
				} else if(!self.selectedOptions.includes(index) && !isDeselect) {
					self.selectedOptions.push(index);
					this.configOptionsComputed.options.options[index].quantity = 1;
				} else if(shouldRemoveFromCart && this.showFlexibleIngredientsOptions) {
					this.removeIngredientFromCart(this.config.options.options[index]);
					this.configOptionsComputed.options.options[index].quantity = 1;
				}
				self.changeConfigSelection(
					self.config,
					self.selectedOptions,
					self.mainGroup,
					self.subProduct,
					self.isFixedMenu
				);
			}
		}
	};
</script>
<style scoped lang="scss">
.background-surface-bottom {
	position: absolute;
	bottom: 0;
	width: 100%;
	height: 10%;
	transform: rotate(180deg);

	img {
		width: 100%;
		height: 100%;
		pointer-events: none;
		-webkit-touch-callout: none;
		touch-action: none;
		-webkit-user-select: none;
		user-select: none;
	}
}
.minus-ingredients {
	padding: 0 !important;
	.layout:not(.sub-product-wrapper){
		.flex{
			margin-top: 20px;
		}
	}
	.subproduct-ingredients-checkbox {
		justify-content: center;
		align-items: center;
		padding: 0;
		max-width: 79px;
	}
	.sub-product-content {
		display: inline-block;
	}
	.subproduct-divider {
		background-color: rgba(0,0,0,.12) !important;
		display: block !important;
		border: none;
		height: 1px;
		min-height: 1px;
		-webkit-box-flex: 1;
		-ms-flex: 1;
		flex: 1;
		width: 100%;
	}
	.sub-product-wrapper {
		height: 110px;
		border-radius: 5px;
		border: solid 3px #26282c;
		background-color: #191a1b;
		.option-name {
			font-family: Dispatch-Bold;
			font-size: 14px;
			font-weight: bold;
			font-stretch: normal;
			font-style: normal;
			line-height: 104px;
			letter-spacing: normal;
			color: #ffffff;
			text-transform: uppercase;
		}
		.option-name-bold {
			font-family: Dispatch-Bold;
		}
	}
}

.spacing-box.flexible-ingredients {
	.sub-product-wrapper {
		justify-content: space-between;
		padding: 0 30px;
	}
	.numbers-part {
		display: flex;
		align-items: center;
		margin-top: 20px;
	}
	.config-quantity-option {
		font-size: 25px;
		border-radius: 3px;
		background-color: #202020;
		border: solid 2px #26282c;
		cursor: pointer;
		width: 44px;
		height: 44px;
		align-items: center;
		display: flex;
		justify-content: center;
		margin: 0 8px 4px 8px;
	}
	.number-with-description {
		min-height: 65px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.config-quantity-option-selected {
		border-color: #FFD800;
	}
	.change-quantity-description {
		height: 21px;
	}
}
.add-remove-btn-wrapper {
	margin: auto 0;
	position: relative;
	div.add-remove-btn {
		position: relative;
		height: inherit;
		text-align: center;
		background-color: #fff;
		border-radius: 6px;
		padding: 0;
		display: flex;

		.v-chip {
			width: 44px;
			height: 44px;
			border-radius: 3px;
			min-width: 44px;
			color: #000;
			background-color: #fff;
			font-size: 22px;
			font-weight: 700;
			display: flex;
			justify-content: center;
			padding-top: 5px;
		}

		.v-btn:last-child {
			background-color: #ffd800;
			color: #231F20;
			height: 44px;
			width: 44px;
			min-width: 44px;
			border-radius: 3px;
		}

		.v-btn:first-child {
			color: #231F20;
			height: 44px;
			width: 44px;
			min-width: 44px;
			border-radius: 3px;
			background-color: #333;
		}
		.add-button-disabled {
			opacity: 0.5;
		}
	}
	.remove-image, .add-image {
		height: 20px;
		width: 20px;
	}
	.remove-image {
		content: url(~@static/gt3/images/icons/minus.svg);
	}
	.add-image {
		content: url(~@static/gt3/images/icons/plus.svg);
	}
}
.change-quantity-price {
	font-size: 16px;
	color: #9B9B9B;
	display: flex;
	justify-content: flex-end;
	line-height: 1;
	margin-top: 5px;
	position: absolute;
	right: 0;
}
.max-ingredient-message {
	font-size: 12px;
	color: #FFD800;
	position: absolute;
	top: -20px;
	right: 0;
	opacity: 0;
	width: max-content;
	animation: fadeOutAnimation 4s;
	display: none;
}
.show-max-ingredient-message {
	display: block;
}
@keyframes fadeOutAnimation {
	0% { opacity: 1; }
	100% { opacity: 0; }
}
@media screen and (max-width: 1537px) {
	.shop-app #app .application--wrap .add-remove-btn-wrapper .add-remove-btn {
		.v-btn, .v-chip {
			margin: auto 5px !important;
		}
	}
}
</style>

